import type { TranslationKey } from '@/lib/i18n/utils';

type TranslateFn = (
  key: TranslationKey,
  params?: Record<string, string | number>,
) => string;

const SIGNUP_ERROR_CODE_TO_TRANSLATION_KEY: Record<string, TranslationKey> = {
  ACCOUNT_EXISTS: 'auth.signupFlow.toast.accountExists',
  DIFFERENT_ORG_ACCOUNT_EXISTS:
    'auth.signupFlow.toast.differentOrgAccountExists',
  ORGANIZATION_TRANSFER_REQUIRED:
    'auth.signupFlow.toast.organizationTransferRequired',
  ACCOUNT_PROVIDER_CONFLICT: 'auth.signupFlow.toast.accountProviderConflict',
  ORGANIZATION_NOT_FOUND: 'auth.signupFlow.toast.organizationNotFound',
};

/**
 * Resolve a client-facing toast message for a signup API error response.
 * Prefers a translated message for a known `errorCode` over the raw English
 * `error` string returned by the server. APIs that do not yet return stable
 * codes can still surface their specific actionable message via `error`.
 */
export function getSignupErrorMessage(
  t: TranslateFn,
  data: { error?: string; errorCode?: string } | null | undefined,
  fallbackKey: TranslationKey,
): string {
  const code = data?.errorCode;
  if (code) {
    const key = SIGNUP_ERROR_CODE_TO_TRANSLATION_KEY[code];
    if (key) {
      const translated = t(key);
      if (translated) return translated;
    }
  }
  if (data?.error) return data.error;
  return t(fallbackKey);
}
